

<div class="">
  <div class="form-group">
    <label>{{'Tiêu đề' | translate}}</label>
    <input type="text" class="form-control" placeholder="" [(ngModel)]="baivietSelect.TieuDe">
  </div>
  <div class="form-group">
    <label>{{'Nội dung bài viết' | translate}}</label>


    <ejs-richtexteditor height='300px' #toolsRTE id='alltoolRTE_bv' [toolbarSettings]='tools' [showCharCount]='true'
                        [(value)]='baivietSelect.NoiDung'
                        [maxLength]='maxLength' [fileManagerSettings]='fileManagerSettings' [quickToolbarSettings]='quickToolbarSettings'
                        (actionBegin)='handleFullScreen($event)' (actionComplete)='actionCompleteHandler($event)'>
    </ejs-richtexteditor>


    <div id='rteContent' style='display: none'>

    </div>


  </div>
  <div class="form-group">
    <label>{{'Từ khóa' | translate}}</label>
    <input type="text" class="form-control" placeholder="" [(ngModel)]="baivietSelect.KeyWord">
  </div>
